import { Controller } from "@hotwired/stimulus";
import { normalizeText, smartMatch } from "../../utils/smart_search";

/**
 * A list of boxes to tick on a one-page form (29/10/2026): a search that
 * narrows it, « Tout cocher » on what is shown, and the count of what is
 * ticked, written wherever a `count` target stands (the action bar too).
 *
 * <form data-controller="pick-list" data-pick-list-labels-value='{"one":"1 élève","other":"%{count} élèves"}'>
 *   <input data-pick-list-target="search" data-action="input->pick-list#filter">
 *   <button type="button" data-action="pick-list#toggleAll">Tout cocher</button>
 *   <label data-pick-list-target="item" data-searchable="ABENA Marie">
 *     <input type="checkbox" data-action="pick-list#count">
 *   </label>
 *   <span data-pick-list-target="count"></span>
 */
export default class extends Controller {
  static targets = ["search", "item", "count", "empty", "submit"];
  static values = { labels: Object };

  connect() {
    this.count();
  }

  filter() {
    const query = normalizeText(this.searchTarget.value);
    let shown = 0;
    this.itemTargets.forEach((item) => {
      const match = smartMatch(item.dataset.searchable || "", query);
      item.classList.toggle("hidden", !match);
      if (match) shown++;
    });
    if (this.hasEmptyTarget) this.emptyTarget.classList.toggle("hidden", shown > 0);
  }

  // Ticks what is shown, or unticks it when all of it is already ticked.
  toggleAll() {
    const boxes = this.visibleBoxes();
    const tick = !boxes.every((box) => box.checked);
    boxes.forEach((box) => { box.checked = tick; });
    this.count();
  }

  count() {
    const ticked = this.itemTargets.filter((item) => this.box(item)?.checked).length;
    const labels = this.labelsValue;
    const text = this.label(labels, ticked).replace("%{count}", ticked);
    this.countTargets.forEach((target) => { target.textContent = text; });
    this.submitTargets.forEach((button) => { button.disabled = ticked === 0; });
  }

  // `zero` when given: in French, 0 takes the singular (« 0 élève coché »).
  label(labels, ticked) {
    if (ticked === 0 && labels.zero) return labels.zero;
    return (ticked === 1 ? labels.one : labels.other) || "%{count}";
  }

  visibleBoxes() {
    return this.itemTargets.filter((item) => !item.classList.contains("hidden"))
      .map((item) => this.box(item)).filter((box) => box && !box.disabled);
  }

  box(item) {
    return item.querySelector('input[type="checkbox"]');
  }
}
